<div class="cds-body">
  <div class="cds-sidebar">
    <div class="cds-sidebar-toggle">
    </div>
    <div class="cds-sidebar-header">
      <div class="cds-sidebar-header-logo">
        <div class="expanded">
          <img src="assets/img/logo-coloured-s1-whitelogo.png" style="width: 200px;" alt="Logo">
        </div>
      </div>
    </div>
    <app-sidebar></app-sidebar>
  </div>
  <div class="cds-content">
    <app-header></app-header>
    <div class="cds-container container-fluid">
      <router-outlet (activate)="onActivate()"></router-outlet>
    </div>
  </div>
</div>